export const MuiInputLabel = {
  styleOverrides: {
    root: {
      '&.MuiFormLabel-root.MuiInputLabel-root.smallInputLabel:not(.MuiInputLabel-shrink)':
        {
          transform: 'translate(14px, 8px) scale(1)',
        },
      '&.MuiFormLabel-root.errorInputLabel.MuiInputLabel-shrink': {
        color: 'var(--error-main, #D32F2F)',
      },
      '&.MuiFormLabel-root.Mui-error:not(.MuiInputLabel-shrink)': {
        color: 'var(--text-secondary, #808080)',
      },
      '&.MuiFormLabel-root.Mui-error:not(.MuiInputLabel-shrink) .MuiInputLabel-asterisk':
        {
          color: 'var(--text-secondary, #808080)',
        },
      '&.hasSelectIcon:not(.MuiInputLabel-shrink)': {
        paddingLeft: '28px',
      },
      '&.low:not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 8px) scale(1)',
      },
    },
  },
}
